export default __webpack_public_path__ + "static/media/chip.f88a902d.png";